/**
 * Product branding — the ONE place the product name lives.
 * Change `productName` here and every app, email, PWA manifest and service name follows.
 */
const productName = 'ShriPOS';

export const BRAND = Object.freeze({
  productName,
  adminAppName: `${productName} Admin`,
  printAgentName: `${productName} Print Agent`,
  poweredByText: `Powered by ${productName}`,
  pwaShortName: productName,
  pwaDescription: `${productName} - fast billing for food kiosks and quick-service counters`,
  themeColor: '#c2410c',
  backgroundColor: '#fff7ed',
});

export const PRODUCT_NAME = BRAND.productName;
